// src/pages/Accommodations.jsx
import React from 'react';

const Accommodations = () => {
  return (
    <div className="page-container">
      <h1 className="page-title">Accommodations</h1>
      <p>Information on various lodging options, from hotels to guesthouses, in pilgrimage cities.</p>
    </div>
  );
};
export default Accommodations;